<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div id="overlay" >
            <div class="loader"></div>
          </div>
          <div slot="header">
            <b-row>
              <b-col><strong>Hub Details</strong></b-col>
              <b-col class="text-right" v-if="usertype==1">
                <a :href="loadurl" target="_blank" v-if="hubcount_length>0">
                  <b-button variant="primary" @click="downlaodloadurl">Download</b-button>
              </a>
              </b-col>
            </b-row>
          </div>
          
        
            <div class="container" v-if="hubcount_length>0">
                <div role="tablist">
              
                  <b-card no-body class="mb-1" v-for="(dashbordcount,index) in hubCount" :key="dashbordcount.hub_id">
                    <b-card-header  header-tag="header" class="p-1" role="tab"  v-bind:id="'collapse' + index" @click=" gethubdetails(dashbordcount.hub_id);">
                      <div v-if="dashbordcount.loadcount==0">
                        <b-button block   variant="info" v-b-toggle="'accordion-1' + dashbordcount.hub_id">
                          <b-row>
                            <b-col class="upperdiv">
                              <span v-b-tooltip.hover title="Hub Id">#{{ dashbordcount.hub_id }}</span>
                            </b-col>
                            <b-col  class="upperdiv">
                              <span v-b-tooltip.hover title="Hub Title">{{ dashbordcount.hub_title }}</span>
                            </b-col>
                            <b-col class="upperdiv" v-if="hubIsAsn == 'NO'">
                              <span v-b-tooltip.hover>Space Utilized : {{ dashbordcount.spaceutil }} ton ({{((parseFloat(dashbordcount.spaceutil) || 0) / (parseFloat(dashbordcount.totalspace) || 0) * 100).toFixed(2) === 'Infinity' || isNaN((parseFloat(dashbordcount.spaceutil) || 0) / (parseFloat(dashbordcount.totalspace) || 0) * 100)? 0 : ((parseFloat(dashbordcount.spaceutil) || 0) / (parseFloat(dashbordcount.totalspace) || 0) * 100).toFixed(2)}}%)</span>
                              <!-- {{(parseFloat(dashbordcount.spaceutil) / parseFloat(dashbordcount.totalspace) * 100).toFixed(2) === 'Infinity' ? 0 : (parseFloat(dashbordcount.spaceutil) / parseFloat(dashbordcount.totalspace) * 100).toFixed(2)}} -->
                            </b-col>
                            <b-col class="upperdiv" v-if="hubIsAsn == 'NO'">
                              <span v-b-tooltip.hover >Free Space : {{ dashbordcount.freespace }} ton</span>
                            </b-col>
                            <b-col class="upperdiv1" v-if="hubIsAsn == 'NO'">
                              <span v-b-tooltip.hover >Total Space : {{ dashbordcount.totalspace }} ton</span>
                            </b-col>
                          </b-row>
                        </b-button>
                      </div>

                      <div v-else>
                        <b-button block   variant="info" v-b-toggle="'accordion-1' + dashbordcount.hub_id">
                          <b-row style="align-items: left;">
                            <b-col class="upperdiv">
                              <span v-b-tooltip.hover title="Hub Id">#{{ dashbordcount.hub_id }}</span>
                            </b-col>
                            <b-col class="upperdiv"> 
                              <span v-b-tooltip.hover title="Hub Title">{{ dashbordcount.hub_title }}</span>
                            </b-col>
                            <b-col class="upperdiv" v-if="hubIsAsn == 'NO'">
                              <span v-b-tooltip.hover>Space Utilized : {{ dashbordcount.spaceutil }} ton ({{((parseFloat(dashbordcount.spaceutil) || 0) / (parseFloat(dashbordcount.totalspace) || 0) * 100).toFixed(2) === 'Infinity' || isNaN((parseFloat(dashbordcount.spaceutil) || 0) / (parseFloat(dashbordcount.totalspace) || 0) * 100)? 0 : ((parseFloat(dashbordcount.spaceutil) || 0) / (parseFloat(dashbordcount.totalspace) || 0) * 100).toFixed(2)}}%)</span>
                               <!-- {{(parseFloat(dashbordcount.spaceutil) / parseFloat(dashbordcount.totalspace) * 100).toFixed(2) === 'Infinity' ? 0 : (parseFloat(dashbordcount.spaceutil) / parseFloat(dashbordcount.totalspace) * 100).toFixed(2)}} -->
                            </b-col>
                            <b-col class="upperdiv" v-if="hubIsAsn == 'NO'">
                              <span v-b-tooltip.hover >Free Space : {{ dashbordcount.freespace }} ton</span>
                            </b-col>
                            <b-col class="upperdiv1" v-if="hubIsAsn == 'NO'">
                              <span v-b-tooltip.hover>Total Space : {{ dashbordcount.totalspace }} ton</span>
                            </b-col>
                            <b-col>
                              <a  :href="downlaodhuburl+'hub_id='+dashbordcount.hub_id+`&&`+`is_asn=`+(route_id == 'normal' ? 'NO': 'YES')" target="_blank"><b-button v-b-tooltip.hover title="Download Reports" size="sm"><i class="fa fa-download"></i></b-button>
                              </a>
                            </b-col>
                          </b-row>
                        </b-button>
                      </div>
                    </b-card-header>

                    <b-collapse accordion="my-accordion-1" role="tabpanel" v-bind:id="'accordion-1' + dashbordcount.hub_id">
                      <b-card-body>
                        <div role="tablist1" v-if="Zonecountlength>0" style="margin-top: 10px;">
                        
                        
                          <b-card no-body class="mb-1" v-for="(ZoneCount,index) in ZonewiseCount" :key="ZoneCount.zone_id">
                            
                            <b-card-header header-tag="header" class="p-1" role="tab" v-bind:id="'collapse' + index" @click=" gethubList(ZoneCount.zone_id);">
                              
                              <b-button block  v-b-toggle="'accordion-2' + dashbordcount.hub_id + ZoneCount.zone_id" variant="warning">
                                <b-row style="text-align: center;">
                                  <b-col class="upperdiv">
                                    <span>Zone Title: {{ZoneCount.zone_title}} - {{ ZoneCount.zone_no }}</span>
                                  </b-col>
                                  <b-col class="upperdiv">
                                    <span>Load Count: {{ZoneCount.loadcount}}</span>
                                  </b-col>
                                  <b-col class="upperdiv">
                                    <span>MPS Count: {{ZoneCount.zonecount}}</span>
                                  </b-col>
                                  <b-col class="upperdiv" v-if="zoneIsAsn == 'NO'">
                                    <span >Space Utilized : {{ ZoneCount.spaceutil }} ton ({{((parseFloat(ZoneCount.spaceutil) || 0) / (parseFloat(ZoneCount.totalspace) || 0) * 100).toFixed(2) === 'Infinity' || isNaN((parseFloat(ZoneCount.spaceutil) || 0) / (parseFloat(ZoneCount.totalspace) || 0) * 100)? 0 : ((parseFloat(ZoneCount.spaceutil) || 0) / (parseFloat(ZoneCount.totalspace) || 0) * 100).toFixed(2)}}%)</span>
                                       <!-- {{(parseFloat(ZoneCount.spaceutil) / parseFloat(ZoneCount.totalspace) * 100).toFixed(2) === 'Infinity' ? 0 : (parseFloat(ZoneCount.spaceutil) / parseFloat(ZoneCount.totalspace) * 100).toFixed(2)}} -->
                                  </b-col>
                                  <b-col class="upperdiv" v-if="zoneIsAsn == 'NO'">
                                    <span >Free Space : {{ ZoneCount.freespace }} ton</span>
                                  </b-col>
                                  <b-col class="upperdiv1" v-if="zoneIsAsn == 'NO'">
                                    <span >Total Space : {{ ZoneCount.totalspace }} ton</span>
                                  </b-col>
                                </b-row>
                              </b-button>
                            </b-card-header>
                            <b-collapse  v-bind:id="'accordion-2' + dashbordcount.hub_id + ZoneCount.zone_id " accordion="my-accordion-2" role="tabpanel">
                              <b-card-body>
                                <b-card-text>
                                  <b-row>
                                    <b-col md="12">
                                      <div v-if="HubAwbListlength > 0 ">
                                        <a  :href="downlaodhuburl+'hub_id='+dashbordcount.hub_id +'&&'+'zone_id='+ ZoneCount.zone_id+`&&`+`is_asn=`+(route_id == 'normal' ? 'NO': 'YES')"  target="_blank"><b-button variant="warning" style="float: right; margin-bottom : 15px;" v-b-tooltip.hover title="Download Reports">Download</b-button></a>
                                      </div>
                                    </b-col>
                                    <b-col md="12" v-if="HubAwbListlength>0 &&route_id=='asn'">
                                      <div style="border: 1px solid #e7e7e7;
                                      padding: 10px;">
                                        <b-row>
                                          <b-col md="12" class="text-left">
                                            <pre style="font-weight:bold; font-size:14px;"> Total Volumetric Weight :-</pre>
                                          </b-col>
                                            <b-col md="4" v-for="city in citytotalweight" :key="city.hub_id">
                                              <span>
                                                <b>{{city[0]}}</b> = 
                                                <span style="color: red;"> {{Number(city[1]).toFixed(4)}}</span>
                                              </span>
                                            </b-col>
                                        </b-row>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col md="12">
                                      <div style="margin-top: 10px;">
                                        <b-table show-empty responsive :busy="isBusy" :items="items" :fields="fields"  :bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" :tbody-tr-class="rowClass"> 
    
                                          <div slot="table-busy" class="text-center text-danger my-2">
                                            <b-spinner class="align-middle">
                                            </b-spinner>
                                            <strong>Loading...</strong>
                                          </div> 
    
                                          <template slot="parentawb" slot-scope="row">
                                            <button v-b-tooltip.hover title="View Details" @click="viewparentawbDetails(row.item)" style="background-color:white !important;" class="btn btn-link"  >
                                              <span style="color:#1b8eb7">{{row.item.parentawb}}</span>
                                           
                                           </button>
                                          </template>
                                          
    
                                          <template slot="invoiceno" slot-scope="row">
                                            {{row.item.invoiceno}}
                                            <br>
                                           
                                              <span style="color:#1b8eb7">{{row.item.inward_process}}</span>
                                               <br>
                                              <span v-if="row.item.defective_boxes > 0 " class="badge " style="background-color:rgb(235 113 100);color:white; font-size: 11px;padding:6px;padding-top: 4px;"   >Defective Count :  {{ row.item.defective_boxes }}</span>
                                              <span v-if="row.item.short_boxes > 0 " class="badge " style="background-color:rgb(23, 130, 109);color:white;font-size: 11px;padding:6px;padding-top: 4px;"   
                                              >Shortage Box Count :  {{ row.item.short_boxes }}</span>
                                            </template> 
    
                                          <template slot="mpscount" slot-scope="row">
                                            <button v-b-tooltip.hover title="View Count Details" @click="viewProduct(row.item)" style="background-color:white !important;" class="btn btn-link">
                                            <span style="color:#1b8eb7"> {{row.item.boxcount}}/{{ row.item.loadcount }}</span>
                                            </button>
                                          </template>  
                                          
                                          <template slot="sourceaddress" slot-scope="row">
                                            <span v-b-tooltip.hover :title='row.item.sourceaddress'>
                                              {{ row.item.sourceaddress.substring(0,40)+".." }}
                                            </span>
                                          </template>
    
                                          <template slot="destinationaddress" slot-scope="row">
                                            <span v-b-tooltip.hover :title='row.item.destinationaddress'>
                                              {{ row.item.destinationaddress.substring(0,40)+".." }}
                                            </span>
                                          </template>
                                          
                                        </b-table>
                                      </div>
                                    </b-col>
                                  </b-row>
                                </b-card-text>
                              </b-card-body>
                            </b-collapse>
                          </b-card>
                        </div>
                        <div v-else style="text-align: center;">
                          <span>No Data Found</span>
                        </div>
                      <!-- first collapse end -->
                      </b-card-body>

                    </b-collapse>
                  </b-card>
                </div>  
            </div>
            <div v-else style="text-align: center;">
              <span>No Hub Data Found</span>
            </div> 

          <!-- open model -->

          <b-modal size="xl" title="AWB Details" v-model="awbdetailsmodal" @ok="awbdetailsmodal = false" hide-footer>
            <template slot="default" slot-scope="{ hide }">
               <b-row class="col-md-12" > 
                      
                      <div class="col-md-3">
                        <span><b>Parent Awb:</b></span>&nbsp;
                        <span>{{parentawbdetail.parentawb}}</span>
                        
                      </div>
                      <div class="col-md-3">
                        <span><b>Invoice NO. :</b></span>&nbsp;
                        <span>{{parentawbdetail.invoiceno}}</span>
                        
                      </div>
                      <div class="col-md-3">
                        <span><b>Vehicle ID :</b></span>&nbsp;
                        <span>{{parentawbdetail.vehicle_id}}</span>
                      </div>
                      <div class="col-md-3">
                        <span><b>Shipment Status :</b></span>&nbsp;
                        <span>{{parentawbdetail.shipmentstatus}} </span>
                        
                      </div>
                      <template slot="calulatededd" slot-scope="row">
                        <span>{{row.item.calulatededd}} </span>
                      </template>
                </b-row>
                <br>
                <b-row class="col-md-12" > 
                   <div class="col-md-3">
                        <span><b>MPS Count:</b></span>&nbsp;
                        <span>{{parentawbdetail.mpscount}}</span>
                        
                      </div>
                      <div class="col-md-3">
                        <span><b>Created Date :</b></span>&nbsp;
                        <span>{{parentawbdetail.createddate}} </span>
                        
                      </div>
                      <div class="col-md-3">
                        <span><b>Last Modified Date :</b></span>&nbsp;
                        <span>{{parentawbdetail.lastmodifieddate}}</span>
                      </div>
                      <div class="col-md-3">
                        <span><b>Pick Up Date :</b></span>&nbsp;
                        <span>{{parentawbdetail.pickupdatetime}}</span>
                        
                      </div>
                     
                </b-row>
                <br>
                <b-row class="col-md-12" >
                <div class="col-md-3">
                        <span><b>Delivery Status :</b></span>&nbsp;
                        <span>{{parentawbdetail.deliverystatus}}</span>
                </div> 
                <div class="col-md-3">
                  <span><b> Source TIN NO. :</b></span>&nbsp;
                  <span>{{parentawbdetail.sourcetinno}} {{parentawbdetail.unit}}</span>
                  
                </div>
                 <div class="col-md-3">
                        <span><b>Sources Poc Person Name :</b></span>&nbsp;
                        <span>{{parentawbdetail.sourcespocpersonname}} </span>
                        
                      </div>
                      <div class="col-md-3">
                        <span><b>Source Company :</b></span>&nbsp;
                        <span>{{parentawbdetail.sourcecompanyname}}</span>
                      </div> 
                     
                  
                     
                </b-row>
                <br>

                <b-row class="col-md-12" >
            
                 <div class="col-md-3">
                        <span><b> Source Mailid :</b></span>&nbsp;
                        <span>{{parentawbdetail.sourceemailid}} </span>
                        
                      </div>
                      
                   <div class="col-md-3">
                        <span><b>Source Mobile No :</b></span>&nbsp;
                        <span>{{parentawbdetail.sourcemobileno}}</span>
                        
                      </div>
                     
                      
                      <div class="col-md-3">
                        <span><b>Source Type :</b></span>&nbsp;
                        <span>{{parentawbdetail.sourcetype}}</span>
                        
                      </div>
                     
                      <div class="col-md-3">
                        <span><b> Source Address :</b></span>&nbsp;
                        <span>{{parentawbdetail.sourceaddress}} </span>
                        
                      </div>
                </b-row>
                   <br>
                <b-row class="col-md-12" >
               
            
                      
                   <div class="col-md-3">
                        <span><b>Source City :</b></span>&nbsp;
                        <span>{{parentawbdetail.sourcecity}}</span>
                        
                      </div>
                      <div class="col-md-3">
                        <span><b>Source State :</b></span>&nbsp;
                        <span>{{parentawbdetail.sourcestate}}</span>
                </div> 
                      
                      <div class="col-md-3">
                        <span><b>Source Pincode :</b></span>&nbsp;
                        <span>{{parentawbdetail.sourcepincode}}</span>
                        
                      </div>
                      <div class="col-md-3">
                        <span><b>Destination TIN NO.:</b></span>&nbsp;
                        <span>{{parentawbdetail.destinationtinno}}</span>
                        
                      </div>
                     
                </b-row>
                      <br>
                <b-row class="col-md-12" >
                  <div class="col-md-3">
                    <span><b>Destination Type:</b></span>&nbsp;
                    <span>{{parentawbdetail.destinationtype}}</span>
                    
                  </div>
                <div class="col-md-3">
                        <span><b>Destination Company :</b></span>&nbsp;
                        <span>{{parentawbdetail.destinationcompanyname}}</span>
                </div> 
                 <div class="col-md-3">
                        <span><b>Mail Id :</b></span>&nbsp;
                        <span>{{parentawbdetail.destinationemailid}} </span>
                        
                      </div>
                      
                   <div class="col-md-3">
                        <span><b>Destination Mobile No :</b></span>&nbsp;
                        <span>{{parentawbdetail.destinationmobileno}}</span>
                        
                      </div>
                     
                      
                      <div class="col-md-3">
                        <span><b>Destination Poc Name :</b></span>&nbsp;
                        <span>{{parentawbdetail.destinationspocpersonname}}</span>
                        
                      </div>
                     
                </b-row>
                   <br>
                <b-row class="col-md-12" >
               
                 <div class="col-md-3">
                        <span><b> Destination Address :</b></span>&nbsp;
                        <span>{{parentawbdetail.destinationaddress}} </span>
                        
                      </div>
                      
                   <div class="col-md-3">
                        <span><b>Destination City :</b></span>&nbsp;
                        <span>{{parentawbdetail.destinationcity}}</span>
                        
                      </div>
                      <div class="col-md-3">
                        <span><b>Destination State :</b></span>&nbsp;
                        <span>{{parentawbdetail.destinationstate}}</span>
                </div> 
                      
                      <div class="col-md-3">
                        <span><b>Destination Pincode :</b></span>&nbsp;
                        <span>{{parentawbdetail.destinationpincode}}</span>
                        
                      </div>
                      <div class="col-md-3">
                        <span><b>EDD :</b></span>&nbsp;
                        <span>{{parentawbdetail.calulatededd}}</span>
                        
                      </div>
                       <div class="col-md-12 pull-right"> 
                      <div slot="footer" class="text-right">
                      
                        <b-button  size="sm" variant="danger" @click="detailsCancel()">Close</b-button>
                      </div>
                    </div>
                     
                </b-row>
            </template>
            
            <template slot="modal-footer" slot-scope="{ cancel }">
              <b-button size="sm" variant="danger" @click="detailsCancel()" style="display:none">
                Cancel
              </b-button>
            </template>
          </b-modal>


          <b-modal size="lg" title="MPS Count Details" v-model="productdetailsModal" @ok="productdetailsModal = false" hide-footer>
        
              <template slot="default" slot-scope="{ hide }">
              <b-row>
              <b-col sm="12" class="text-right">
                <p> <b>Total Records :<span style="color:red;"> {{mpstotalRows}}</span></b> </p>
              </b-col>   
              <div style="float: left;" v-if="route_id=='normal'">
                <!-- v-if="this.mpstotalRows > 0" -->
                <span class="badge ml-2" 
                style="background-color:rgb(192, 57, 43); color: white;font-size: 11px; padding: 5px 5px 5px;">DB</span> Damage Box&nbsp;&nbsp;
                <span class="badge ml-2" 
                  style="background-color:rgb(23, 130, 109); color: white;font-size: 11px; padding: 3px;">SB</span> Shortage Box&nbsp;&nbsp;
              </div>
              <div style="float: left;" v-if="route_id=='asn'">
                <!-- v-if="this.mpstotalRows > 0" -->
                <span class="badge ml-2" 
                style="background-color:rgb(192, 57, 43); color: white;font-size: 11px; padding: 5px 5px 5px;">FD</span> Full Damage Box&nbsp;&nbsp;
                <span class="badge ml-2" 
                style="background-color:rgb(71 80 107 / 97%); color: white;font-size: 11px; padding: 5px 5px 5px;">PD</span> Partial Damage Box&nbsp;&nbsp;
                <span class="badge ml-2" 
                  style="background-color:rgb(23, 130, 109); color: white;font-size: 11px; padding: 3px;">SB</span> Shortage Box&nbsp;&nbsp;
              </div>
              <b-col sm="12"> 
                <!-- <b-col sm="12"> -->
              <b-table show-empty stacked="md"  :items="mpsitems"  :fields="mpsfields"  :current-page="mpscurrentPage"  :per-page="mpsperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusyMps" >
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>  
                      <template slot="shippingid" slot-scope="row">
                        <span>{{row.item.shippingid}}</span>
                        <br>
                        <div v-if="route_id=='normal'">
                          <span v-if="row.item.is_defective=='YES'" class="badge " style="background-color:#c0392b;color:white;font-size: 11px;padding:5px;padding-top: 4px;cursor: pointer;"  v-b-modal.defective_image_modal @click="Viewimagedetails(row.item)">DB</span>
                        </div>
                        <div v-if="route_id=='asn'">
                          <span v-if="row.item.boxdamage_status_asn=='Full Damage Box'" class="badge " style="background-color:#c0392b;color:white;font-size: 11px;padding:5px;padding-top: 4px;cursor: pointer;"  v-b-modal.defective_image_modal @click="Viewimagedetails(row.item)">FD</span>
                          <span v-if="row.item.boxdamage_status_asn=='Partial Damage Box'" class="badge " style="background-color:rgb(71 80 107 / 97%);color:white;font-size: 11px;padding:5px;padding-top: 4px;cursor: pointer;"  v-b-modal.defective_image_modal @click="Viewimagedetails(row.item)">PD</span>
                        </div>
                        <span v-if="row.item.is_shortage=='Yes'" class="badge " style="background-color:rgb(23, 130, 109);color:white;font-size: 9px;padding: 3px;cursor: pointer;">SB</span>
                      </template>
                      <template slot="mpsvalue" slot-scope="row">
                        <span>{{row.item.mpsvalue}}</span>
                      </template>
                      <template slot="physicalweight" slot-scope="row">
                        <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                      </template>
                      <template slot="breadth" slot-scope="row">
                        <span> {{row.item.breadth}} {{row.item.lbhunit}}</span>
                      </template>
                      <template slot="length" slot-scope="row">
                        <span> {{row.item.length}} {{row.item.lbhunit}}</span>
                      </template>
                      <template slot="height" slot-scope="row">
                        <span> {{row.item.height}} {{row.item.lbhunit}}</span>
                      </template>
                      <template slot="deliverystatus" slot-scope="row">
                        <span v-if="row.item.deliverystatus=='INTransit'" style="color: red;"> {{row.item.deliverystatus}} </span>
                        <span v-else> {{row.item.deliverystatus}} </span>
                      </template>
                      <template slot="shipmentstatus" slot-scope="row">
                        <span v-if="row.item.deliverystatus=='INTransit'" style="color: red;">{{row.item.shipmentstatus}} </span>
                        <span v-else>{{row.item.shipmentstatus}}</span>
                      </template>
                    
              </b-table> 
            <!-- </b-col> -->
            </b-col>
            </b-row> 
              <b-row>
              <b-col md="6" class="my-1" v-if="mpstotalRows>10">
                <b-pagination
                      v-model="mpscurrentPage"
                      :total-rows="mpstotalRows"
                      :per-page="mpsperPage"
                      class="my-0"
                    ></b-pagination>
            
              </b-col> 
            </b-row>
                <div class="col-md-12 pull-right"> 
                        <div slot="footer" class="text-right">
                        
                          <b-button  size="sm" variant="danger" @click="modalCancel()">Close</b-button>
                        </div>
                      </div>
              </template>
              <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button size="sm" variant="danger" @click="modalCancel()" style="display:none">
                  Cancel
                </b-button>
              </template>
          </b-modal>

          <b-modal size="md" id="defective_image_modal" title="Defective Image" hide-footer>
            <div v-if="selected_user_details.defective_imageurl==null" class="text-center">
              No Record Found
            </div>
            <div v-else class="text-center">
              <img :src="selected_user_details.defective_imageurl" width="100%" height="100%" />
            </div>
          </b-modal>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  data() {
    return {
      isBusy: false,      
      hubCount : [],
      ZonewiseCount :[],
      Counts :[],
      items :[],
      fields  :[
            { key: 'parentawb', label: 'Parent AWB',sortable: true},
            { key: 'invoiceno', label: 'Load ID',sortable: true},
            { key: 'accounttype', label: 'Account Type',sortable: true },
            { key: 'sourceaddress', label: 'Source Address',sortable: true},
            { key: 'destinationaddress', label: 'Destination Address',sortable: true },
            { key: 'destinationcity', label: 'Destination City',sortable: true},
            { key: 'mpscount', label: 'Zone Scanned/Total Scanned',sortable: true},
            { key: 'actual_weight', label: 'Actual Weight',sortable: true},
           { key: 'volumetric_weight', label: 'Volumetric Weight',sortable: true},
            { key: 'deliverystatus', label: 'Delivery Status',sortable: true},
            { key: 'shipmentstatus', label: 'Shipment Status',sortable: true},
            { key: 'createddate', label: 'Created Date',sortable: true },
            { key: 'calulatededd', label: 'EDD',sortable: true }
          ],
      hubcount_length:0,
      Zonecountlength:0,
      HubAwbListlength :0,
      downlaodhuburl :'',
      parentawbdetail : '',
      awbdetailsmodal:false,
      productdetailsModal:false,
      mpsitems:[],
      mpsfields:[
        // { key: 'mpsid', label: 'MPS Id', sortable: true, sortDirection: 'desc' },
        { key: 'shippingid', label: 'MPS No', sortable: true, sortDirection: 'desc' },
        { key: 'mpsvalue', label: 'MPS Value', sortable: true, sortDirection: 'desc' },
        
        { key: 'length', label: 'Length', sortable: true, sortDirection: 'desc' },
        { key: 'breadth', label: 'Breadth', sortable: true, sortDirection: 'desc' },
          
          { key: 'height', label: 'Height', sortable: true, sortDirection: 'desc' },
        { key: 'physicalweight', label: 'Physical Weight', sortable: true, sortDirection: 'desc' },
        { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
        { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
        // { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
          
      ],
      isBusyMps:false,
      mpstotalRows: 0,
      mpscurrentPage: 1,
      mpsperPage: 10,
      changeColor:false,
      selected_user_details :'',
      route_id :'',
      citytotalW:[],
      citytotalweight:[],
      loadurl:'',
      usertype :'',
      zoneIsAsn:"",
      hubIsAsn:'',
       
    }
  },
  created() {
    this.route_id = this.$route.params.id;
    console.log("this.route_id",this.route_id)

    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.user_id = userInfo.sysusermasterid;
    this.usertype = userInfo.user_type;
  
    this.hubDashboardcount();
    const huburl = `${CONSTANTS.MIGRATION_API_URL}/getHubZoneWiseCsvReport?`;
    this.downlaodhuburl=huburl;
    console.log("0000000000000000000000000",this.downlaodhuburl)
    
  },
  methods: {

      downlaodloadurl(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        
        this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getDashboardHubToHubBulkDownload?sysusermasterid=`+userInfo.sysusermasterid+`&&`+`is_asn=`+(this.route_id == 'normal' ? 'NO': 'YES')+`&&`+`usertype=`+userInfo.user_type
        console.log("this.loadurl",this.loadurl)
      },
        
      // getDashboardHubToHubBulkDownload?sysusermasterid=142&is_asn=NO&usertype=1


      hubDashboardcount : function(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`,
          hub_id:userInfo.user_type!=1?`${userInfo.hub_id}`:"",
          is_asn: this.route_id=='normal' ? 'NO': 'YES',
        }
        console.log("obj",obj)
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getDashboardHubToHubCount`,obj)
          .then(result => {
            // console.log("result",result)
            if (result.body.returnmsg === "Successful") {
            this.hubCount=result.body.returnvalue;
            this.hubIsAsn = result.body.is_asn;
            this.hubcount_length=result.body.returnvalue.length;
            // console.log("hubCount",this.hubCount);
            }else{
                this.hubCount=[];
                this.hubcount_length=0;
            }
          }).catch(ex => {
            console.log("error", ex);
        });
      },

      gethubdetails : function (hub_id) {
        document.getElementById("overlay").style.display = "block";
        this.ZonewiseCount=[];
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`,
          hub_id :`${hub_id}`,
          is_asn: this.route_id=='normal' ? 'NO': 'YES',
        }
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getDashboardZonewiseCount`,obj)
          .then(result => {
            document.getElementById("overlay").style.display = "none";
            if (result.body.returnmsg === "Successful") {
            this.ZonewiseCount=result.body.returnvalue;
            this.zoneIsAsn = result.body.is_asn;
            this.Zonecountlength=result.body.returnvalue.length;
            }else{
                this.ZonewiseCount=[];
                this.Zonecountlength=0;
            }
          }).catch(ex => {
            console.log("error", ex);
        });
      },

      gethubList : function (zone_id) {
        document.getElementById("overlay").style.display = "block";
        this.isBusy = true;
        console.log("this.hub_id;",zone_id)
        const obj={
          zone_id :`${zone_id}`,
          is_asn: this.route_id=='normal' ? 'NO': 'YES',
        }
        console.log("object",obj)
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getDashboardHubToHubAwbList`,obj)
          .then(result => {
            console.log("result",result)
            this.isBusy = false;
            document.getElementById("overlay").style.display = "none";
            if (result.body.returnmsg === "Successful") {
            this.items=result.body.returnvalue;
            if (result.body.citytotalweight) {
              console.log("oooooooooooooooooo",result.body.citytotalweight)
              this.citytotalW = result.body.citytotalweight;
            }
            
            if (this.citytotalW) {
              console.log("11111111111111111111111111",this.citytotalW)
              this.citytotalweight = Object.entries(this.citytotalW)
              console.log("ppppppppppppppppppppppppppppppppppppp",this.citytotalweight)
            }
        
            this.HubAwbListlength = result.body.returnvalue.length;
            // console.log("HubAwbListlength",this.HubAwbListlength)
            }else{
                this.items=[];
               this.HubAwbListlength =0;
            }
          }).catch(ex => {
            console.log("error", ex);
        });
      },

      // open models

      viewparentawbDetails :function (values) {
        this.awbdetailsmodal=true;
        this.parentawbdetail=values;
      },

      detailsCancel : function () {
        this.awbdetailsmodal=false;
      },

      viewProduct:function(value){
        this.mpscurrentPage=1;
        this.productdetailsModal=true;
        this.isBusyMps = true;
        // console.log("value",value);
        let userData = localStorage.getItem('userData');
        let userInfo = JSON.parse(userData);
      
        
        
        let obj = {
          parentawb: value.parentawb,
        }
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getMPSListFromLoad`,obj)
            .then(result => {
              console.log("TTTTT",result);
                this.isBusyMps = false;
                if(result.body.returnmsg === "successful"){
                
                this.mpsitems  = result.body.returnvalue;
                // console.log("HHHHH",this.mpsitems);
                  this.mpstotalRows = result.body.returnvalue.length
                  // console.log("RRRRR",this.mpstotalRows);
                
                }else {
                this.mpsitems  = [];
                this.mpstotalRows = 0
                }
            }).catch(ex => {
              console.log('error', ex)
            })
        
      },

      modalCancel:function(){
        this.productdetailsModal=false;
      },

      Viewimagedetails : function (data){
            this.selected_user_details=data;
            console.log("rrrrrrrrrrr",this.selected_user_details);
      },

      rowClass(item, type) {
        if(item){
          if(item.boxcount==item.loadcount){
            return 'table-success'
          }
        }
      },
  },
}
</script>

<style>
  .back {
    background-color: #f09642;
  }
  .upperdiv{
    border-right:1px solid grey;
        text-align: left;
  }
  .upperdiv1{
    
        text-align: left;
  }
</style>